export const TECH_ISSUE_TITLE = {
  BOTH: 'BOTH_SOCKET_FAIL',
  LIVE: 'LIVE_DATA_SOCKET_FAIL',
  MARKET: 'PORTFOLIO_SOCKET_FAIL',
} as const;

export const FCM_NOTIFICATIONS_DEBOUNCE_DELAY = 500;
